import { useRef, useState } from 'react';
import { useAmp } from 'next/amp';
import styled from 'styled-components';
import Lightbox from 'yet-another-react-lightbox';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';

import StyledImage from '../Image';

export type GalleryProps = {
  images: string[];
};

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media only screen and (min-width: 576px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const Gallery: React.FC<GalleryProps> = (props) => {
  const { images } = props;
  // ======================= HOOKS
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const thumbnailsRef = useRef(null);
  const isAmp = useAmp();

  // ======================= STATE

  // ======================= API

  // ======================= EVENTS
  const handleThumbnailClick = (index: number) => {
    setOpen(true);
    setActiveIndex(index);
  };

  // ======================= VARIABLES

  // ======================= RENDER FUNCTIONS

  // ======================= VIEWS
  return (
    <div>
      <p
        style={{
          fontWeight: 700,
          fontSize: 16,
          marginBottom: 20,
        }}
      >
        Gallery
      </p>
      <GalleryGrid
        style={
          isAmp
            ? {
                height: 'auto',
                width: '70vw',
                maxWidth: '100%',
              }
            : {}
        }
      >
        {images.map((image, index) => {
          return (
            <div key={index}>
              <StyledImage
                src={image}
                alt=""
                width={600}
                height={338}
                onClick={() => handleThumbnailClick(index)}
                imageStyle={{
                  cursor: 'pointer',
                }}
                isGallery={true}
              />
            </div>
          );
        })}
        {!isAmp ? (
          <Lightbox
            open={open}
            index={activeIndex}
            thumbnails={{ ref: thumbnailsRef, border: 0 }}
            slides={images?.map((e) => {
              return { src: e as string };
            })}
            plugins={[Thumbnails, Counter]}
            close={() => {
              setOpen(false);
            }}
            animation={{
              navigation: 0,
            }}
          />
        ) : (
          <amp-image-lightbox
            id="lightbox1"
            layout="nodisplay"
            data-close-button-aria-label="true"
          >
            <div
              className="lightbox"
              //@ts-expect-error exoect type error
              on="tap:my-lightbox.close"
              role="button"
              tabindex="0"
            />
          </amp-image-lightbox>
        )}
      </GalleryGrid>
    </div>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Gallery;
